import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { PermissionService } from './permission.service';
@Injectable({
  providedIn: 'root',
})
export class AuthGuardService  {
  constructor(
    public auth: AuthenticationService, 
    public permission:PermissionService,
    public router: Router) {}

  canActivate( route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    var module:any=route.data['module'];
    var action:any=route.data['action'];

    //console.log(module, action, this.permission.capable(module,action), state);


    if(this.auth.isAuthenticated() && this.permission.capable(module,action)){
      return true;
    }else{

      if (this.auth.isAuthenticated() && this.isOwnProfileAccess(route, state)) {
        return true;
      }

      if (module === 'manage_users') {
        const gotId = this.getRouteUserId(route, state);

        if (!gotId) {
          return true;
        }
    }
    
    if (state.url.split('?')[0] === '/dashboard/setup/allUser/view') {
      const gotId = this.getRouteUserId(route, state);

      if (!gotId) {
        return true;
      }
    }

      this.router.navigateByUrl("/dashboard/error", {state: { access: { module, action }}});
      return false;
    }
    
  }

  /** View/edit own user profile without manage_users */
  private isOwnProfileAccess(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!route.data['allowOwnProfile']) {
      return false;
    }
    const queryId = this.getRouteUserId(route, state);
    const loggedInId = this.auth.getUserId();
    return !!queryId && !!loggedInId && String(queryId) === String(loggedInId);
  }

  private getRouteUserId(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): string | null {
    const id = route.queryParams?.['id'] ?? state.root.queryParams?.['id'];
    return id != null && id !== '' ? String(id) : null;
  }

  canActivateChild(): Observable<boolean> | Promise<boolean> | boolean {
    if(this.auth.isAuthenticated()){
      return true;
    }
    else
    { 
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigateByUrl("/login");
      return false;
    }
  }

  

}